import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { initPwaInstallCapture } from './helpers/pwaInstall'
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
// Import styles of packages that you've installed.
// All packages except `@mantine/hooks` require styles imports
import '@mantine/core/styles.css';
import 'mantine-datatable/styles.css';
import '@mantine/dates/styles.css';
import './index.css'
import App from './App';
import { ConfigProvider } from './useConfig';
import { HttpClientProvider } from './HttpClientContext';
import { MantineProvider } from '@mantine/core';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { setMsalInstance } from './helpers/TokenRefresh';
import { UserProvider } from './providers/UserContext';
import { LanguageProvider } from './providers/LanguageContext';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient()

// registerType is 'autoUpdate' (see vite.config.ts), so once a new service
// worker activates it should take over silently — but the plugin's default
// injected registration script never wires that up, leaving already-open
// tabs running the old cached bundle indefinitely. Importing the module here
// gets the reload-on-update handling that registerType: 'autoUpdate' implies.
registerSW({ immediate: true });

// Keep the browser's install prompt for our "App installieren" button; the
// event can fire before React has mounted.
initPwaInstallCapture();

// MSAL v4 requires initialize() before the instance is passed to MsalProvider.
// Without this, handleRedirect never resolves and inProgress stays stuck,
// causing the app to hang on "Loading authentication..." indefinitely.
msalInstance.initialize().then(() => {
  setMsalInstance(msalInstance);
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>

          <ConfigProvider>
            <MantineProvider>
              <Notifications/>
              <HttpClientProvider>
                <UserProvider>
                  <LanguageProvider>
                    <App />
                  </LanguageProvider>
                </UserProvider>
              </HttpClientProvider>
            </MantineProvider>
          </ConfigProvider>
        </QueryClientProvider>
        </MsalProvider>
    </StrictMode>
  )
})
